<template>
<v-window vertical touchless v-model="step">
  <v-window-item :value="0">
    <create-statement-form
      @success='statementCreated'
      :relationship-id='relationshipId'
      :invoices="invoices" >
    </create-statement-form>
  </v-window-item>
  <v-window-item :value="1">
    <statement-success
      v-if='newstatement'
      :statement='newstatement'
      @send='step=2'
      @close='$emit("close")'  >
    </statement-success>
  </v-window-item>
  <v-window-item :value="2">
    <send-statement
      @close='$emit("close")'
      v-if='newstatement'
      v-model='newstatement'
      :touch='touchSender' >
    </send-statement>
  </v-window-item>
</v-window>
</template>
<script>
import CreateStatementForm from './CreateStatementForm'
import StatementSuccess from './Success'
import SendStatement from './SendStatement'
export default {
  name: 'CreateStatementWizard',
  components: {
    CreateStatementForm,
    StatementSuccess,
    SendStatement
  },
  props: {
    relationshipId: { required: false },
    invoices: { type: Array, required: true },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      step: 0,
      newstatement: null,
      touchSender: 0
    }
  },
  mounted () {
    if (!this.invoices) {
      this.invoices = []
    }
  },
  watch: {
    invoices () {
      this.step = 0
    },
    touch () {
      this.step = 0
    },
    step () {
      this.touchSender++
    }
  },
  methods: {
    statementCreated (statement) {
      this.step = 1
      this.newstatement = statement
    }
  },
  computed: {
    selectedStatmentClients () {
      if (this.newstatement && this.newstatement.relationship_id) {
        let relationship = this.getRelationById(this.newstatement.relationship_id)
        if (relationship) {
          return [relationship]
        }
      }
      return []
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?0538f0d5